import { render, staticRenderFns } from "./ItemLimitsSaveLayout.vue?vue&type=template&id=0db37af8&scoped=true"
import script from "./ItemLimitsSaveLayout.vue?vue&type=script&lang=js"
export * from "./ItemLimitsSaveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db37af8",
  null
  
)

export default component.exports